//@ts-check

if (!customElements.get("ff-product-recommendations")) {
  class FfProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const productId = this.dataset.productId;
      if (productId) {
        this.fetchRecommendations();
      }
    }

    fetchRecommendations() {
      const { productId, sectionId, intent, limit } = this.dataset;
      
      if (!productId || !sectionId) {
        console.error("ff-product-recommendations: Missing required data attributes");
        return;
      }

      const url = `${window["Shopify"].routes.root}recommendations/products`;
      const params = new URLSearchParams({
        section_id: sectionId,
        product_id: productId,
        limit: limit || "10",
        intent: intent || "related"
      });

      fetch(`${url}?${params}`)
        .then((response) => response.text())
        .then((html) => {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;
          
          const productCards = tempDiv.querySelectorAll(".ff-card-product");
          const productsContainer = this.parentElement;
          const productSlots = productsContainer.querySelectorAll(".ff-theme-block_product-card-slot");
          
          // Check if products are in a slider
          const sliderContainer = productsContainer.closest("ff-slider");
          const swiperWrapper = sliderContainer?.querySelector(".swiper-wrapper");
          let swiperInstance = null;
          
          if (sliderContainer && sliderContainer.ffSwiper) {
            swiperInstance = sliderContainer.ffSwiper;
          }
          
          if (productCards.length > 0) {
            productCards.forEach((productCard, idx) => {
              if (productSlots[idx]) {
                productSlots[idx].replaceWith(productCard);
              } else {
                if (swiperWrapper) {
                  swiperWrapper.appendChild(productCard);
                } else {
                  productsContainer.appendChild(productCard);
                }
              }
            });
          }

          this.remove();
          
          // Update swiper if it exists
          if (swiperInstance) {
            // Use timeout to ensure DOM has updated
            setTimeout(() => {
              swiperInstance.update();
              swiperInstance.updateSlides();
              
              // Reinitialize if needed (e.g., for loop mode)
              if (swiperInstance.params && swiperInstance.params.loop) {
                swiperInstance.loopDestroy();
                swiperInstance.loopCreate();
              }
            }, 100);
          }
        })
        .catch((error) => {
          console.error("ff-product-recommendations: Error loading", error);
          this.style.display = "none";
        });
    }
  }

  customElements.define("ff-product-recommendations", FfProductRecommendations);
}